<template>
  <div id="main">
    <div class="header">Hightech binnenstad</div>
    <!--    <div class="logout">-->
    <!--      <a v-if="$keycloak.authenticated" class="button is-link is-outlined" @click="$keycloak.logoutFn()">-->
    <!--        <span class="icon is-small">-->
    <!--          <i class="fas fa-sign-out-alt" aria-hidden="true"></i>-->
    <!--        </span>-->
    <!--        <span>Logout</span>-->
    <!--      </a>-->
    <!--      <a v-else class="button primary" @click="$keycloak.loginFn()">-->
    <!--        <span class="icon is-small">-->
    <!--          <i class="fas sign-in-alt" aria-hidden="true"></i>-->
    <!--        </span>-->
    <!--        <span>Login</span>-->
    <!--      </a>-->
    <!--    </div>-->
    <Tabs class="mb-10" />
    <DateFilter class="mb-10" v-on:onSelectedPreset="onSelectedPreset" />
    <Surveys class="mb-10" />
    <div class="columns">
      <MapDashboard
        class="column map_container"
        :options="mapOptions"
        :filter="dateFilter"
        :events="events"
        v-on:mapUpdated="onMapUpdated"
        v-on:selectedFeature="onSelectedFeature"
      />
      <Context
        class="column"
        :selectedType="context.selectedType"
        :selectedItem="context.selectedItem"
      />
    </div>
  </div>
</template>

<script>
import config from "../../config/app.config";
import constants from "../constants";
import moment from "moment";

import DateFilter from "./Filter/DateFilter";
import Context from "./Context/Context";
import MapDashboard from "./Map/Map";
import Surveys from "./Surveys/Surveys";
import Tabs from "./Navigation/Tabs";

export default {
  name: "Main",
  components: {
    DateFilter,
    Context,
    MapDashboard,
    Surveys,
    Tabs
  },
  data() {
    return {
      locations: [],
      activeTabIndex: 0,
      dateFilter: {},
      context: {
        selectedType: constants.MAP_LAYER_EVENT_ID,
        selectedItem: {}
      },
      events: {},
      selectedEvent: {},
      mapOptions: {
        style: config.mapStyles.light,
        center: [config.defaultMapCenter.lon, config.defaultMapCenter.lat],
        zoom: null
      }
    };
  },
  mounted() {
    this.loadNavigationTabs(),
      this.loadMapOptions(),
      this.loadDefaultFilter(),
      this.fetchEvents(),
      this.fetchTravelTime(),
      this.fetchTravelIntensity(),
      this.fetchTrackers(),
      this.fetchParkingPlaces(),
      this.fetchCurrentWeather(),
      this.fetchSurveys(),
      this.fetchVrResults(),
      this.fetchTravelTimeTimeSeries(),
      this.fetchTravelIntensityTimeSeries(),
      this.fetchAntea(),
      this.fetchPresets();
  },
  methods: {
    loadNavigationTabs() {
      // Load the navigation tabs from config.
      this.$store.commit("setNavigationTabs", config.dashboardLocations);

      // Get previously stored tab index for navigation.
      let tabIndex = localStorage.getItem(constants.NAV_ACTIVE_TAB);
      if (tabIndex === null) {
        tabIndex = config.dashboardLocations.findIndex(
          loc => loc.name === "Deventer"
        );
        localStorage.setItem(constants.NAV_ACTIVE_TAB, tabIndex);
      }
      if (tabIndex !== null) {
        this.$store.commit("setNavigationTabIndex", tabIndex);
      }
    },
    loadMapOptions() {
      // Get default map center and zoom level.
      var mapCenter = [
        config.defaultMapCenter.lon,
        config.defaultMapCenter.lat
      ];
      var mapZoom = config.defaultMapZoom;

      // Get map center and zoom level from local storage if present.
      if (localStorage.getItem(constants.MAP_CENTER_KEY) !== null) {
        mapCenter = JSON.parse(localStorage.getItem(constants.MAP_CENTER_KEY));
      }
      if (localStorage.getItem(constants.MAP_ZOOM_KEY) !== null) {
        mapZoom = JSON.parse(localStorage.getItem(constants.MAP_ZOOM_KEY));
      }

      // Add values to props.
      this.mapOptions.center = mapCenter;
      this.mapOptions.zoom = mapZoom;
    },
    loadDefaultFilter() {
      // Set the default filter to a week.
      const start = moment()
        .subtract(7, "days")
        .format("YYYY-MM-DD");
      const end = moment().format("YYYY-MM-DD");
      this.$store.commit("setDateFilterStartDate", start);
      this.$store.commit("setDateFilterEndDate", end);
    },
    fetchEvents() {
      this.$store.dispatch("fetchEvents");
    },
    fetchTravelTime() {
      this.$store.dispatch("fetchTravelTime");
    },
    fetchTravelIntensity() {
      this.$store.dispatch("fetchTrafficIntensity");
    },
    fetchTrackers() {
      this.$store.dispatch("fetchTrackers");
    },
    fetchAntea() {
      this.$store.dispatch("fetchAntea");
    },
    fetchVrResults() {
      this.$store.dispatch("fetchVrResults");
    },
    fetchTravelTimeTimeSeries() {
      this.$store.dispatch("fetchTravelTimeTimeSeries");
    },
    fetchTravelIntensityTimeSeries() {
      this.$store.dispatch("fetchTravelIntensityTimeSeries");
    },
    fetchParkingPlaces() {
      //TODO: Find out why if we supply the location in correct
      // for nothing is shown on the map.
      let location = this.$store.getters.navigationActiveTab.name;
      this.$store.dispatch("fetchParkingPlacesByLocation", location);
    },
    fetchCurrentWeather() {
      let location = this.$store.getters.navigationActiveTab.name;
      this.$store.dispatch("fetchCurrentWeather", { location: location });
    },
    fetchSurveys() {
      let location = this.$store.getters.navigationActiveTab.name;
      this.$store.dispatch("fetchSurveys", { location: location });
    },
    fetchPresets() {
      let location = this.$store.getters.navigationActiveTab.name;
      this.$store.dispatch("fetchPresets", location);
    },
    onTabSelected: function(activeTabIndex) {
      // Update the locations for the tabs.
      for (var i = 0; i < this.locations.length; i++) {
        this.locations[i].active = activeTabIndex == i;
      }
      this.activeTabIndex = activeTabIndex;

      // Store active tab in the local storage to survive browser sessions.
      localStorage.setItem(constants.NAV_ACTIVE_TAB, activeTabIndex);

      // Go to location on map.
      this.mapOptions.center = [
        this.locations[this.activeTabIndex].location.lng,
        this.locations[this.activeTabIndex].location.lat
      ];
      this.mapOptions.zoom = config.defaultMapZoom;
    },
    onMapUpdated(options) {
      localStorage.setItem(
        constants.MAP_CENTER_KEY,
        JSON.stringify(options.center)
      );
      localStorage.setItem(constants.MAP_ZOOM_KEY, options.zoom);
    },
    onSelectedFeature(feature) {
      this.context = {
        selectedType: feature.layer.id,
        selectedItem: feature
      };
      //maplayer aanzetten
    },
    onSelectedPreset(feature) {
      if (feature.maplayer === "antea") {
        this.context = {
          selectedType: feature.layer.id,
          selectedItem: feature
        };
        this.fetchAntea();
      }
      // this.fetchVrResults()
      //Plus map?!
    }
  }
};
</script>

<style scoped>
#main {
  margin: 10px;
}

h1.title {
  margin: 14px 0;
}

.header {
  position: absolute;
  font-weight: bold;
  left: 22px;
  top: 20px;
}

.logout {
  position: absolute;
  right: 10px;
}

.map_container {
  width: 70%;
}

.columns {
  height: 670px;
}

.mb-10 {
  margin-bottom: 10px;
}
</style>
